// Types
import type { SummaryType } from "../types"

export function SummaryCard(params: SummaryType): JSX.Element {
  return (
    <div className="min-h-[120px] flex flex-col border border-black">
      <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2">{params.sideLabel}</div>

      <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
        {params.label && <div className="text-sm">{params.label}</div>}
        <div className="text-lg font-bold">{params.value}</div>
      </section>
    </div>
  )
}